module.exports = __webpack_public_path__ + "static/media/down.1ba5cc1c.svg";